import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
// slices
import mailReducer from './slices/mail';
import chatReducer from './slices/chat';
import blogReducer from './slices/blog';
import userReducer from './slices/user';
import productReducer from './slices/product';
import calendarReducer from './slices/calendar';
import kanbanReducer from './slices/kanban';
import dagpacketReducer from './slices/dagpacket';
import dagpacketRolesReducer from './slices/DagpacketRoles';
import dagpacketFlujoReducer from './slices/dagpacketFlujo';
import selectCreateReducer from './slices/selectCreateComponent';
import dagpacketControlPaqReducer from './slices/dagpacketControlPaq';
import settingsFunctionsReducer from './slices/settingsFunctions';
import dagpacketServRecReducer from './slices/dagpacketServRec';
import dagpacketEmpaquetadoReducer from './slices/dagpacketEmpaquetado';
import dagpacketEmpaqueUserReducer from './slices/dagpacketEmpaqueUser';
import dagpacketProductsReducer from './slices/dagpacketProducts';
import dagpacketCreceReducer from './slices/dagpacketCrece';
import dagpacketVencedorReducer from './slices/dagpacketVencedor';
import dagpacketFlujoRecargaServicioReducer from './slices/dagpacketFlujoRecargaServicio';
import metodosPagosReducer from './slices/metodosPagos';
import dagpacketFiltrosReducer from './slices/dagpacketFiltros';

// ----------------------------------------------------------------------

const rootPersistConfig = {
  key: 'root',
  storage,
  keyPrefix: 'redux-',
  whitelist: []
};

const productPersistConfig = {
  key: 'product',
  storage,
  keyPrefix: 'redux-',
  whitelist: ['sortBy', 'checkout']
};

const rootReducer = combineReducers({
  mail: mailReducer,
  chat: chatReducer,
  blog: blogReducer,
  user: userReducer,
  calendar: calendarReducer,
  kanban: kanbanReducer,
  product: persistReducer(productPersistConfig, productReducer),
  dagpacket: dagpacketReducer,
  dagpacketRoles: dagpacketRolesReducer,
  dagpacketFlujo: dagpacketFlujoReducer,
  selectCreate: selectCreateReducer,
  dagpacketControlPaq: dagpacketControlPaqReducer,
  settingsFunc: settingsFunctionsReducer,
  dagpacketServRec: dagpacketServRecReducer,
  dagpacketEmpaquetado: dagpacketEmpaquetadoReducer,
  dagpacketEmpaqueUser: dagpacketEmpaqueUserReducer,
  dagpacketProducts: dagpacketProductsReducer,
  dagpacketCrece: dagpacketCreceReducer,
  dagpacketVencedor: dagpacketVencedorReducer,
  dagpacketFlujoRecargaServicio: dagpacketFlujoRecargaServicioReducer,
  metodosPagos: metodosPagosReducer,
  dagpacketFiltros: dagpacketFiltrosReducer
});

export { rootPersistConfig, rootReducer };
